import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ICountry } from "../../../Pages/Country/ICountry";

export const EditCountrySlice = createSlice({
  name: "EditCountrySlice",
  initialState: {} as IReduxState<ICountry>,
  reducers: {
    EditCountry: (state, _: PayloadAction<ICountry>) => {
      state.isLoading = true;
    },
    successEditCountry: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureEditCountry: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearEditCountryResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  EditCountry,
  failureEditCountry,
  successEditCountry,
  clearEditCountryResponse,
} = EditCountrySlice.actions;

export default EditCountrySlice.reducer;
